<div
  *ngIf="show"
  class="fade"
  [@state]="state"
  (@state.done)="animationDone($event)"
>
 <ng-content #fadeableContent></ng-content>
</div>
